import { ethers } from "ethers";

export const availableNetworks: Record<string, any> = {
  polygon: {
    chainId: `0x${Number(137).toString(16)}`,
    chainName: "Polygon LlamaNodes",
    icon: "/chain_icons/polygon.png",
    displayName: "Polygon",
    nativeCurrency: {
      name: "MATIC",
      symbol: "MATIC",
      decimals: 18,
      contractAddress: "0x0000000000000000000000000000000000001010",
      abb: "MATIC",
    },
    rpcUrls: ["https://polygon-mainnet.infura.io/"],
    blockExplorerUrls: ["https://polygonscan.com/"],
    stableCoins: [
      {
        name: "USD Tether",
        contractAddress: "0xc2132D05D31c914a87C6611C10748AEb04B58e8F",
        abb: "USDT",
        decimals: 6,
      },
      {
        name: "USD Coin (PoS)",
        contractAddress: "0x2791Bca1f2de4661ED88A30C99A7a9449Aa84174",
        abb: "USDC",
        decimals: 6,
      },
      {
        name: "USD Coin",
        contractAddress: "0x3c499c542cef5e3811e1192ce70d8cc03d5c3359",
        abb: "USDC",
        decimals: 6,
      },
      {
        name: "MATIC",
        contractAddress: "0x0000000000000000000000000000000000001010",
        abb: "MATIC",
        decimals: 18,
      },
    ],
  },
  fvm: {
    chainId: `0x${Number(314).toString(16)}`,
    icon: "/chain_icons/FVM.png",
    chainName: "FVM - Mainnet",
    displayName: "Filecoin",
    nativeCurrency: {
      name: "Filecoin",
      symbol: "FIL",
      decimals: 18,
    },
    rpcUrls: ["https://api.node.glif.io"],
    blockExplorerUrls: ["https://filfox.info/en"],
    stableCoins: [
      {
        name: "Axelar USDC",
        contractAddress: "0xEB466342C4d449BC9f53A865D5Cb90586f405215",
        abb: "axlUSDC",
        decimals: 6,
      },
      {
        name: "USDFC",
        contractAddress: "0x80B98d3aa09ffff255c3ba4A241111Ff1262F045",
        abb: "USDFC",
        decimals: 18,
      },  
      {
        name: "Filecoin",
        contractAddress: ethers.ZeroAddress,
        abb: "FIL",
        decimals: 18,
      },
    ],
  },
  base: {
    chainId: `0x${Number(8453).toString(16)}`,
    icon: "/chain_icons/base.png",
    chainName: "Base LlamaNodes",
    displayName: "Base",
    nativeCurrency: {
      name: "Ethereum",
      symbol: "ETH",
      decimals: 18,
    },
    rpcUrls: ["https://base.llamarpc.com"],
    blockExplorerUrls: ["https://basescan.org"],
    stableCoins: [
      {
        name: "USD Tether",
        contractAddress: "0xfde4C96c8593536E31F229EA8f37b2ADa2699bb2",
        abb: "USDT",
        decimals: 6,
      },
      {
        name: "USD Coin",
        contractAddress: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
        abb: "USDC",
        decimals: 6,
      },
      {
        name: "Ethereum",
        contractAddress: ethers.ZeroAddress,
        abb: "ETH",
        decimals: 18,
      },
    ],
  },
};
